"use client";

import { size, theme } from "@/config/theme";
import { SCButton, SCContainerContent } from "@/utils/styledComponents";
import { useTranslations } from "next-intl";
import styled from "styled-components";
import { breakpoints } from "@/utils/breakpoint";
import { useRouter } from "next/navigation";
import { useRecoilValue } from "recoil";
import { appLocale } from "@/recoil/appState";

const GroupSwimmingLesson = () => {
    const td = useTranslations("GroupSwimmingLesson");
    const router = useRouter();
    const localeAppState = useRecoilValue(appLocale);

    return (
        <SCGroupSwimmingLessonWrapper>
            <SCGroupSwimmingLessonContent>
                <div className="text-container">
                    <h2 className="text-largexlarge">{td("title")}</h2>
                    <div className="text-medium">
                        <p>{td("intro-1")}</p>
                        <p>{td("intro-2")}</p>
                    </div>
                </div>
            </SCGroupSwimmingLessonContent>
        </SCGroupSwimmingLessonWrapper>
    );
};

export default GroupSwimmingLesson;

const SCGroupSwimmingLessonWrapper = styled.div`
    background-color: ${theme["color-white"]};
    display: flex;
    justify-content: center;
    padding: ${theme["spacing-lxl"]} 0;
`;

const SCGroupSwimmingLessonContent = styled(SCContainerContent)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    ${breakpoints(
        "flex-direction",
        "",
        [{ [size.px.sxs]: "column-reverse" }],
        "max-width"
    )};

    > div {
        width: 80%;
        ${breakpoints("width", "", [{ [size.px.sxs]: "100%" }], "max-width")};
    }

    .text-container {
        .text-xlarge {
            font-size: ${theme["fontsize-l"]};
            margin-bottom: ${theme["spacing-l"]};
            text-align: left;
        }
        .text-largexlarge {
            font-size: ${theme["fontsize-lxl"]};
            font-weight: 500;
            margin-bottom: ${theme["spacing-m"]};
        }
        .text-medium {
            font-size: ${theme["fontsize-m"]};
            color: ${theme["color-grey"]};
            margin-bottom: ${theme["spacing-l"]};
            text-align: left;
        }

        .text-small {
            font-size: ${theme["fontsize-s"]};
            color: ${theme["color-grey"]};
            margin-bottom: ${theme["spacing-l"]};
        }
    }

    .image-container {
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 400px;
            min-width: 300px;
            height: auto;
            ${breakpoints(
                "width",
                "",
                [{ [size.px.sxs]: "60%" }],
                "max-width"
            )};
        }
    }
`;
